import { NgModule, Component, HostBinding, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { EuiIconModule } from '../atoms';
import { BaseDirective } from '../../base.directive';
import { EuiLabelModule } from '../atoms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './eui-button.component.html',
    selector: 'button[euiButton], eui-button',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiButtonComponent extends BaseDirective {

    @Input()
    get euiBasicButton() { return this._euiBasicButton; }
    set euiBasicButton(value) { this._euiBasicButton = coerceBooleanProperty(value); }
    _euiBasicButton = false;

    @Input()
    get euiButtonCall() { return this._euiButtonCall; }
    set euiButtonCall(value) { this._euiButtonCall = coerceBooleanProperty(value); }
    _euiButtonCall = false;

    @Input()
    get euiButtonBlock() { return this._euiButtonBlock; }
    set euiButtonBlock(value) { this._euiButtonBlock = coerceBooleanProperty(value); }
    _euiButtonBlock = false;

    @Input()
    get euiBlockButton() { return this._euiBlockButton; }
    set euiBlockButton(value) { this._euiBlockButton = coerceBooleanProperty(value); }
    _euiBlockButton = false;

    @Input()
    get euiRaisedButton() { return this._euiRaisedButton; }
    set euiRaisedButton(value) { this._euiRaisedButton = coerceBooleanProperty(value); }
    _euiRaisedButton = false;

    @Input()
    get isLoading() { return this._isLoading; }
    set isLoading(value) { this._isLoading = coerceBooleanProperty(value); }
    _isLoading = false;

    @Input()
    get euiIconButton() { return this._euiIconButton; }
    set euiIconButton(value) { this._euiIconButton = coerceBooleanProperty(value); }
    _euiIconButton = false;

    @Input()
    get euiLineWrap() { return this._euiLineWrap; }
    set euiLineWrap(value) { this._euiLineWrap = coerceBooleanProperty(value); }
    _euiLineWrap = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            this.euiBasicButton ? `eui-button--basic` : ``,
            this.euiButtonBlock ? `eui-button--block` : ``,
            this.euiRaisedButton ? `eui-button--raised` : ``,
            this.euiBlockButton ? `eui-button--block` : ``,
            this.isLoading ? `eui-button--loading` : ``,
            this.euiIconButton ? `eui-button--icon-only` : ``,
            this.euiLineWrap ? `eui-button--line-wrap` : ``,
            super.getCssClasses('eui-button'),
        ].join(' ').trim();
    }

    @HostBinding('attr.data-e2e') @Input() e2eAttr: string = 'eui-button';
    @HostBinding('attr.role') role = 'button'; // in case eui-button selector is used and not the button html element

    constructor() {
        super();
    }
}

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiLabelModule,
        TranslateModule,
    ],
    declarations: [
        EuiButtonComponent,
    ],
    exports: [
        EuiButtonComponent,
    ],
})
export class EuiButtonModule { }
